export const likedVideosActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_ALL_LIKED_VIDEOS: "GET_ALL_LIKED_VIDEOS",
  ADD_VIDEO_TO_LIKED_VIDEOS: "ADD_VIDEO_TO_LIKED_VIDEOS",
  REMOVE_VIDEO_FROM_LIKED_VIDEOS: "REMOVE_VIDEO_FROM_LIKED_VIDEOS",
};
